/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_View_DetailsInputs */

const en_audit_view_details = /** @type {(inputs: Audit_View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Details`)
};

const es_audit_view_details = /** @type {(inputs: Audit_View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Detalles`)
};

/**
* | output |
* | --- |
* | "View Details" |
*
* @param {Audit_View_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_view_details = /** @type {((inputs?: Audit_View_DetailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_View_DetailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_view_details(inputs)
	return es_audit_view_details(inputs)
});